import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../hooks/api';

function StatusBadge({ status }) {
  return <span className={`badge badge-status badge-${status}`}>{status.replace('_', ' ')}</span>;
}

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [recentDevices, setRecentDevices] = useState([]);

  const load = useCallback(async () => {
    const [s, devices] = await Promise.all([api.get('/api/stats'), api.get('/api/devices')]);
    setStats(s);
    setRecentDevices(devices.slice(0, 6));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="page">
      <h1 className="page-title">Dashboard</h1>
      <div className="metric-grid">
        <div className="metric-card"><div className="metric-label">Total Devices</div><div className="metric-value">{stats?.devices ?? '—'}</div></div>
        <div className="metric-card"><div className="metric-label">Assigned</div><div className="metric-value">{stats?.assigned ?? '—'}</div></div>
        <div className="metric-card"><div className="metric-label">Available</div><div className="metric-value">{stats?.available ?? '—'}</div></div>
        <div className="metric-card"><div className="metric-label">In Repair</div><div className="metric-value">{stats?.in_repair ?? '—'}</div></div>
        <div className="metric-card"><div className="metric-label">Employees</div><div className="metric-value">{stats?.employees ?? '—'}</div></div>
        {user?.role === 'admin' &&
          <div className="metric-card"><div className="metric-label">Branches</div><div className="metric-value">{stats?.branches ?? '—'}</div></div>
        }
      </div>
      <div className="section">
        <div className="section-header">
          <h2>Recent Devices</h2>
          <Link to="/devices" className="link">View all →</Link>
        </div>
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Asset Tag</th><th>Device</th><th>Type</th>
                <th>Assigned To</th><th>Branch</th><th>Status</th>
              </tr>
            </thead>
            <tbody>
              {recentDevices.map(d => (
                <tr key={d.id}>
                  <td className="mono">{d.asset_tag}</td>
                  <td>{d.name}{d.brand ? ` · ${d.brand}` : ''}</td>
                  <td><span className="tag">{d.type}</span></td>
                  <td>{d.employee_name ? `${d.employee_name}${d.emp_code ? ` (${d.emp_code})` : ''}` : '—'}</td>
                  <td>{d.branch_name}</td>
                  <td><StatusBadge status={d.status} /></td>
                </tr>
              ))}
              {recentDevices.length === 0 && <tr><td colSpan={6} className="empty">No devices yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
